export default __webpack_public_path__ + "static/media/digital-organization.76b35c56.svg";